import { z } from 'zod';
export const createBranchInput = z.object({
    code: z.string().regex(/^\d{3}$/, 'Tres dígitos, p. ej. 001'),
    name: z.string().trim().min(2, 'Requerido').max(120),
    address: z.string().trim().max(250).nullable().optional(),
    phone: z
        .string()
        .trim()
        .regex(/^\d{8,20}$/, 'Solo números')
        .nullable()
        .optional(),
});
export const updateBranchInput = createBranchInput.omit({ code: true }).partial().extend({
    isActive: z.boolean().optional(),
});
export const createTerminalInput = z.object({
    code: z.string().regex(/^\d{5}$/, 'Cinco dígitos, p. ej. 00001'),
    name: z.string().trim().min(2, 'Requerido').max(120),
});
export const updateTerminalInput = createTerminalInput.omit({ code: true }).partial().extend({
    isActive: z.boolean().optional(),
});
//# sourceMappingURL=branches.js.map